import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import Logo from "@/components/Logo";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useLanguage } from "@/context/LanguageContext";

const COMPANY_EMAIL = "aivvvora@gmail.com";

export default function Footer() {
  const { t } = useLanguage();

  const cols = [
    {
      title: t("footer.company"),
      links: [
        { label: t("nav.home"), to: "/" },
        { label: t("nav.about"), to: "/about" },
        { label: t("nav.solutions"), to: "/solutions" },
        { label: t("nav.careers"), to: "/careers" },
      ],
    },
    {
      title: t("footer.engage"),
      links: [
        { label: t("nav.ai"), to: "/ai" },
        { label: t("nav.contact"), to: "/contact" },
        { label: t("nav.earlyAccess"), to: "/early-access" },
        { label: t("footer.developers"), to: "/developers" },
      ],
    },
    {
      title: t("footer.legal"),
      links: [
        { label: t("footer.privacy"), to: "/about" },
        { label: t("footer.terms"), to: "/about" },
        { label: t("footer.security"), to: "/security" },
      ],
    },
  ];

  return (
    <footer className="relative border-t border-white/10 bg-[#05080D]" data-testid="main-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-5">
          <div className="col-span-2">
            <Logo imgClassName="h-14" />
            <p className="mt-4 max-w-xs text-sm text-slate-400 leading-relaxed">{t("footer.tagline")}</p>
            <a href={`mailto:${COMPANY_EMAIL}`} className="mt-4 inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-email">
              <Mail className="h-4 w-4 text-[#4F8CFF]" /> {COMPANY_EMAIL}
            </a>
            <div className="mt-5">
              <LanguageSwitcher compact={false} />
            </div>
          </div>
          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-mono uppercase tracking-[0.18em] text-slate-500">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((l, i) => (
                  <li key={`${col.title}-${i}`}><Link to={l.to} className="text-sm text-slate-400 hover:text-white transition-colors">{l.label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 vora-divider-glow" />
        <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">© 2026 Vvvoraa · Remote-first: Singapore · Germany · India · Dubai</p>
          <p className="text-xs text-slate-500">{COMPANY_EMAIL}</p>
        </div>
      </div>
    </footer>
  );
}
